import { call, put, takeEvery } from 'redux-saga/effects';
import { getIdToken, getErrorData } from '../../utils/helperFunctions';
import { getVaultActListRequest } from '../../utils/httpRequests';
import {
  GET_VAULT_ACT_LIST_REQUESTED,
  GET_VAULT_ACT_LIST_FAILED,
  GET_VAULT_ACT_LIST_SUCCESS,
} from '../actions/actionTypes';

// sagas
export function* getVaultActListSaga({ payload: { vaultActSearchCriteria } }) {
  try {
    const idToken = yield getIdToken();
    const data = yield call(
      getVaultActListRequest,
      vaultActSearchCriteria,
      idToken,
    );
    yield put({
      type: GET_VAULT_ACT_LIST_SUCCESS,
      payload: { data },
    });
  } catch (err) {
    yield put({
      type: GET_VAULT_ACT_LIST_FAILED,
      payload: { error: getErrorData(err) },
    });
  }
}

// watchers
export function* getVaultActListWatcher() {
  yield takeEvery(GET_VAULT_ACT_LIST_REQUESTED, getVaultActListSaga);
}
